import { render, staticRenderFns } from "./LiveLesson.vue?vue&type=template&id=07ce7e6a&lang=pug&"
import script from "./LiveLesson.vue?vue&type=script&lang=js&"
export * from "./LiveLesson.vue?vue&type=script&lang=js&"
import style0 from "./LiveLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports